import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupInitialComponent } from './group-initial.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
    declarations: [
        GroupInitialComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    exports: [
        GroupInitialComponent
    ]
})
export class GroupInitialModule { }
